/* eslint-disable  no-console */

export default function debugLogger(source: string) {
  return function debug(...args: unknown[]) {
    console.debug(`%c[${source}]`, 'color:green', ...args);
  };
}
